import { render } from "./FooTer.vue?vue&type=template&id=7f04aeb5&scoped=true"
import script from "./FooTer.vue?vue&type=script&lang=js"
export * from "./FooTer.vue?vue&type=script&lang=js"

import "./FooTer.vue?vue&type=style&index=0&id=7f04aeb5&scoped=true&lang=css"
import "./FooTer.vue?vue&type=style&index=1&id=7f04aeb5&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f04aeb5"]])

export default __exports__